(function() {
  const TITLE_STRETCH_X = 0.84;
  const TITLE_STRETCH_Y = 1.24;

  function fitCover(cover) {
    if (!cover) return;
    const title = cover.querySelector('.pct-cart-book-cover__title');
    const inner = cover.querySelector('.pct-cart-book-cover__title-inner');
    if (!title || !inner) return;

    inner.style.transform = '';

    const maxWidth = title.clientWidth || title.offsetWidth;
    const textWidth = inner.scrollWidth;
    if (!maxWidth || !textWidth) return;

    const stretchedWidth = textWidth * TITLE_STRETCH_X;
    const fitScale = stretchedWidth > maxWidth ? maxWidth / stretchedWidth : 1;
    inner.style.transform = `scale(${fitScale}) scaleX(${TITLE_STRETCH_X}) scaleY(${TITLE_STRETCH_Y})`;
  }

  window.pctFitCartBookCovers = function(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.pct-cart-book-cover')) fitCover(scope);
    scope.querySelectorAll('.pct-cart-book-cover').forEach(fitCover);
  };

  function scheduleFit(root) {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        window.pctFitCartBookCovers(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scheduleFit(document); });
  } else {
    scheduleFit(document);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
      setTimeout(function() { scheduleFit(document); }, 50);
    }).catch(function() {});
  }

  window.addEventListener('resize', function() { scheduleFit(document); });

  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.pct-cart-book-cover') || node.querySelector('.pct-cart-book-cover'))) {
          scheduleFit(node);
          return;
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
